import React from 'react';
import { connect } from 'react-redux';

import gameKit from '../../../../GameKit';
import SideBarPageNav from '../SideBarPageNav';

import settings from '../../../../settings';

import { setOpenDropdownItem, updateHistory } from '../../../actions/blokEditorActions';

import BlokEditorItems from './BlokEditorItems';

class BlokEditor extends React.Component {
    updateShape = e =>
        gameKit.levelEditor.blokEditor.updateBlokSettings({
            shape: parseInt(e.target.value, 10)
        });

    updateBlokStateLook = (type, data) => {
        const { dispatch } = this.props;
        if (data && data.value) {
            dispatch(updateHistory(data.value));
        }
        gameKit.levelEditor.blokEditor.updateBlokStateLook(type, data);
    };

    setOpenDropdownItem = item => {
        const { dispatch } = this.props;
        dispatch(setOpenDropdownItem(item));
    };

    updateBlokStateSettings = s => gameKit.levelEditor.blokEditor.updateBlokStateSettings(s);

    render() {
        const { blokEditor, closeSideBar, setActiveItem, activeItem, actionReactionAfterwards } = this.props;

        return (
            <>
                <SideBarPageNav blokEditor={blokEditor} setActiveItem={setActiveItem} activeItem={activeItem} actionReactionAfterwards={actionReactionAfterwards} />
                <div className="side-bar-header">
                    <div className="side-bar-header-col side-bar-header-text">{blokEditor.name}</div>
                    <div className="side-bar-header-col side-bar-header-close" onClick={closeSideBar} role="none">
                        <img src={`${settings.assetsPath}img/icons/bouwsteen-sluit.png`} alt="Sluiten" title="Sluiten" />
                    </div>
                </div>
                <BlokEditorItems
                    blokEditor={blokEditor}
                    changeState={false}
                    updateShape={this.updateShape}
                    updateBlokStateLook={this.updateBlokStateLook}
                    updateBlokStateSettings={this.updateBlokStateSettings}
                    setOpenDropdownItem={this.setOpenDropdownItem}
                    assetHistory={blokEditor.history}
                />
            </>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    blokEditor: state.blokEditor
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BlokEditor);
